import * as types from './ActionTypes';
import { gcApi } from 'config/axios';

/**
 * NEW BADGES
 */

// Page
export const setBadgesPageView = (view, displayName) => ({
    type: types.SET_BADGES_PAGE_VIEW,
    view,
    displayName
});

export const resetBadgesPageView = () => ({
    type: types.RESET_BADGES_PAGE_VIEW
});

export const setBadgesTypeFilter = (value) => ({
    type: types.SET_BADGES_TYPE_FILTER,
    value
});

export const setBadgesPointsFilter = (value) => ({
    type: types.SET_BADGES_POINTS_FILTER,
    value
});

export const resetBadgesFilters = () => ({
    type: types.RESET_BADGES_FILTERS
});

export const resetBadges = () => ({
    type: types.RESET_BADGES
});

// Latest Earned
export const receiveLatestEarnedBadges = (data) => ({
    type: types.RECEIVE_LATEST_EARNED_BADGES,
    data,
    receivedAt: Date.now()
});

export const failedLatestEarnedBadges = () => ({
    type: types.FAILED_LATEST_EARNED_BADGES,
    data: null,
    receivedAt: Date.now()
});

export const fetchLatestEarnedBadges = (displayName) => ({
    type: types.REQUEST_LATEST_EARNED_BADGES,
    displayName
});

// Badge Attributes - Types and Difficulties
export const requestBadgeAttributes = () => ({
    type: types.REQUEST_BADGE_ATTRIBUTES
});

export const receiveBadgeAttributes = (data) => ({
    type: types.RECEIVE_BADGE_ATTRIBUTES,
    data,
    receivedAt: Date.now()
});

export const failedBadgeAttributes = () => ({
    type: types.FAILED_BADGE_ATTRIBUTES,
    data: null,
    receivedAt: Date.now()
});

// Earned
export const receiveEarnedBadges = (data) => ({
    type: types.RECEIVE_EARNED_BADGES,
    data,
    receivedAt: Date.now()
});

export const requestEarnedBadges = (categoryId, difficultyId, start, limit) => ({
    type: types.REQUEST_EARNED_BADGES,
    categoryId,
    difficultyId,
    start,
    limit
});

export const failedEarnedBadges = () => ({
    type: types.FAILED_EARNED_BADGES,
    data: null,
    receivedAt: Date.now()
});

// Available
export const receiveAvailableBadges = (data) => ({
    type: types.RECEIVE_AVAILABLE_BADGES,
    data,
    receivedAt: Date.now()
});

export const requestAvailableBadges = (categoryId, difficultyId, start, limit) => ({
    type: types.REQUEST_AVAILABLE_BADGES,
    categoryId,
    difficultyId,
    start,
    limit
});

export const requestAvailableBadgesWithOptions = ({
    categoryId,
    difficultyId,
    start,
    limit,
    showExclusive = false
}) => ({
    type: types.REQUEST_AVAILABLE_BADGES,
    categoryId,
    difficultyId,
    start,
    limit,
    showExclusive
});

export const failedAvailableBadges = () => ({
    type: types.FAILED_AVAILABLE_BADGES,
    data: null,
    receivedAt: Date.now()
});

// Comparison
export const requestComparisonBadges = (displayName, categoryId, difficultyId, start, limit) => ({
    type: types.REQUEST_COMPARISON_BADGES,
    displayName,
    categoryId,
    difficultyId,
    start,
    limit
});

export const receiveComparisonBadges = (data) => ({
    type: types.RECEIVE_COMPARISON_BADGES,
    data,
    receivedAt: Date.now()
});

export const failedComparisonBadges = () => ({
    type: types.FAILED_COMPARISON_BADGES,
    data: null,
    receivedAt: Date.now()
});

// Leaderboard
export const receiveBadgesLeaderboard = (data, isAppending) => ({
    type: types.RECEIVE_BADGES_LEADERBOARD,
    data,
    isAppending,
    receivedAt: Date.now()
});

export const failedBadgesLeaderboard = () => ({
    type: types.FAILED_BADGES_LEADERBOARD,
    data: null,
    receivedAt: Date.now()
});

export const fetchBadgesLeaderboard = (start, limit) => ({
    type: types.FETCH_BADGES_LEADERBOARD,
    start: start,
    limit: limit
});

export const resetBadgesLeaderboard = () => ({
    type: types.RESET_BADGES_LEADERBOARD
});

// Badge Details
export const fetchBadgeDetails = (badgeId, displayName) => {
    let url = `/badge-service/badge/detail/v2/${badgeId}`;

    if (displayName) {
        url = `/badge-service/badge/${displayName}/earned/detail/${badgeId}`;
    }

    return gcApi.get(url).then(({ data }) => data);
};

// Mark as seen
export const updateViewedBadges = (badgeIds) => ({
    type: types.UPDATE_VIEWED_BADGES,
    badgeIds
});

export const onBadgeMarkedAsSeen = () => ({
    type: types.BADGE_MARKED_AS_SEEN
});

// Connections for badge
export const fetchConnectionsForBadge = (badgeId, start, limit) => {
    return gcApi
        .get(`/badge-service/badge/earned/detail/${badgeId}/connections`, {
            params: {
                start,
                limit
            }
        })
        .then((response) => {
            return response.data;
        });
};

// Repeatable Badge Details
export const fetchRepeatableBadgeDetails = (displayName, badgeId, start, limit) => {
    return gcApi
        .get(`/badge-service/badge/${displayName}/earned/detail/repeatable/v2/${badgeId}`, {
            params: {
                start,
                limit
            }
        })
        .then((response) => {
            return response.data;
        });
};

//Activity badges
export const requestActivityBadges = (displayName, activityId) => ({
    type: types.REQUEST_ACTIVITY_BADGES,
    displayName,
    activityId
});

export const receiveActivityBadges = (data) => ({
    type: types.RECEIVE_ACTIVITY_BADGES,
    data,
    receivedAt: Date.now()
});

export const failedActivityBadges = () => ({
    type: types.FAILED_ACTIVITY_BADGES,
    data: null,
    receivedAt: Date.now()
});

//Daily summary badges
export const requestDailySummaryBadges = (displayName, calendarDate) => ({
    type: types.REQUEST_DAILY_SUMMARY_BADGES,
    displayName,
    calendarDate
});

export const receiveDailySummaryBadges = (data) => ({
    type: types.RECEIVE_DAILY_SUMMARY_BADGES,
    data,
    receivedAt: Date.now()
});

export const failedDailySummaryBadges = () => ({
    type: types.FAILED_DAILY_SUMMARY_BADGES,
    data: null,
    receivedAt: Date.now()
});

// UpdateBadgeLevelUpViewed
export const updateBadgeLevelUpViewed = () => {
    return gcApi.put('/badge-service/badge/levelupviewed', {});
};
